import { Spin } from 'antd';

/**
 * 로딩중 컴포넌트
 */
const LoadingPage = (props) => {
  return (
    <>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 1000
      }}>
        <Spin size="large" />
        <div style={{ marginTop: '16px', fontSize: '16px', color: '#666', fontWeight: '500' }}>{props.message}</div>
      </div>
    </>
  );
};

export default LoadingPage;
